import React, { useState } from "react";

import { DeleteModal, MTable } from "../v3";
import { PurchaseItemColumns } from "../../pages/vendor/constants";

export const ItemsTable = ({ loading, setPurchaseItems, purchaseItems, onEditItem }) => {
  const [deleteModal, setDeleteModal] = useState({
    isOpen: false,
    itemId: undefined,
  });

  const handleDeleteItemClick = (item) => {
    setDeleteModal({
      isOpen: true,
      itemId: item.purchaseItemId,
    });
  };

  const deletePurchaseItem = () => {
    setPurchaseItems(purchaseItems.filter((item) => item.purchaseItemId !== deleteModal.itemId));
    closeDeleteModal();
  };

  const closeDeleteModal = () => {
    setDeleteModal({
      isOpen: false,
      itemId: undefined,
    });
  };

  const handleActions = (purchaseData, actionType) => {
    if (actionType === "edit") {
      onEditItem(purchaseData);
    } else if (actionType === "delete") {
      handleDeleteItemClick(purchaseData);
    }
  };

  const columnHeaders = PurchaseItemColumns(handleActions);

  const rows = purchaseItems.map((item, index) => ({
    id: index,
    sl: index + 1,
    name: item.name,
    purchaseItemId: item.purchaseItemId,
    price: item.price,
    quantity: `${item.quantity} ${item.unitOfMeasure || ""}`,
    tax: item.taxPercentage,
    total: Number(
      item.quantity * item.price + (item.taxPercentage ? item.quantity * item.price * (item.taxPercentage / 100) : 0),
    ).toFixed(2),
  }));

  return (
    <>
      <MTable loading={loading} columnHeaders={columnHeaders} tableRows={rows} hideFooter />
      <DeleteModal
        isOpen={deleteModal.isOpen}
        onClose={closeDeleteModal}
        onConfirm={deletePurchaseItem}
        message="Are you sure you want to remove this item?"
      />
    </>
  );
};
